import React from "react";
import PropTypes from "prop-types";
import Fieldset from "../../common/Fieldset";
import DownloadUploadFiles from "../../common/DownloadUploadFiles";
import TextAreaInput from "../../common/TextAreaInput";
import FieldsetSubHeader from "../../common/FieldsetSubHeader";

import * as domainConstants from "../../../constants/DomainConstants";

const PrioritaireBeschikkingForm = props => {

    const PRIOTITAIREBESCHIKKING_TOOLTIP = "Beschrijf in welke mate de reële behoefte (gewenst gebruik) per doelgroep al dan niet wordt ingevuld. Geef een inschatting van het aantal te verwachten gebruiksuren over een periode van 5 jaar vanaf de voorlopige oplevering per doelgroep.";
    const {
        beoordelingscriteria,
        disabled,
        errors,
        onChange,
        color,
        fileTypes,
        mapDeleteFile,
        mapDropFiles,
        getFilesForDossierComponent,
        fileSessionStarted,
        validationMessageType
    } = props;

    return (
        <Fieldset
            title="Prioritaire beschikking">
            <FieldsetSubHeader>Toon aan in welke mate de topsporttrainingsinfrastructuur prioritair ter beschikking staat van bij de Vlaamse overheid geregistreerde topsporters. Beschrijf daarbij in welke mate de betreffende sportinfrastructuur ter beschikking wordt gesteld voor de verschillende doelgroepen, d.z. de door de Vlaamse overheid ondersteunde topsportprogramma’s per topsportfederatie (talentdetectie-, ontwikkelings- en/of prestatieprogramma’s).</FieldsetSubHeader>
            <TextAreaInput
                name="mateVanPrioritaireBeschikkingVoorTopsport"
                label="Prioritaire beschikking (max. 2.000 tekens)"
                value={beoordelingscriteria.mateVanPrioritaireBeschikkingVoorTopsport}
                onChange={onChange}
                height={5}
                disabled={disabled}
                tooltip={PRIOTITAIREBESCHIKKING_TOOLTIP}
                validationMessage={errors ? errors.mateVanPrioritaireBeschikkingVoorTopsport : ''}
                validationMessageType={validationMessageType} />
            <DownloadUploadFiles
                dossierId={beoordelingscriteria.dossierId}
                title="Prioritaire beschikking"
                center
                optional
                disabled={disabled}
                color={color}
                tab={domainConstants.DocumentTab.Criteria}
                component={domainConstants.ComponentName.PrioritaireBeschikkingen}
                onDelete={mapDeleteFile(domainConstants.ComponentName.PrioritaireBeschikkingen)}
                onDrop={mapDropFiles(domainConstants.ComponentName.PrioritaireBeschikkingen)}
                files={getFilesForDossierComponent(domainConstants.ComponentName.PrioritaireBeschikkingen)}
                fileTypes={fileTypes.PrioritaireBeschikkingen}
                validationMessage={errors ? errors.ulPrioritaireBeschikkingen : ''}
                validationMessageType={validationMessageType}
                fileSessionStarted={fileSessionStarted} />
        </Fieldset>
    );
};

PrioritaireBeschikkingForm.propTypes = {
    beoordelingscriteria: PropTypes.object.isRequired,
    disabled: PropTypes.bool,
    errors: PropTypes.object,
    color: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    fileTypes: PropTypes.object,
    mapDeleteFile: PropTypes.func.isRequired,
    mapDropFiles: PropTypes.func.isRequired,
    getFilesForDossierComponent: PropTypes.func.isRequired,
    fileSessionStarted: PropTypes.bool,
    validationMessageType: PropTypes.string
};

export default PrioritaireBeschikkingForm;